import { getBasePath } from '@prophecy/utils/history';

const impersonatingUserFlag = 'prophecy.ui.isImpersonating';

export function setImpersonatingFlag(enabled: boolean) {
  if (enabled) {
    const expirationTime = new Date().getTime() + 30 * 60 * 1000;
    localStorage.setItem(impersonatingUserFlag, expirationTime.toString());
  } else {
    localStorage.removeItem(impersonatingUserFlag);
  }
}

export function isImpersonatingUser() {
  const flagExpirationTime = localStorage.getItem(impersonatingUserFlag);

  if (flagExpirationTime) {
    const currentTime = new Date().getTime();
    const expirationTime = parseInt(flagExpirationTime);

    if (currentTime < expirationTime) {
      return true;
    } else {
      localStorage.removeItem(impersonatingUserFlag);
    }
  }

  return false;
}
export function redirectParentToUrl(url: string) {
  const baseUrl = `${window.location.origin}${getBasePath()}`;

  if (!url.startsWith(baseUrl)) url = `${baseUrl}${url}`;

  window.top?.postMessage({ type: 'ProphecyAppSignup', url }, '*');
}
